<div
  class="relative flex min-h-0 w-full flex-1 flex-col"
  data-cid="bemobi-checkout-modal"
  [style.min-height.px]="iframeHeight()"
>
  @if (isIframeLoading()) {
    <div
      class="absolute inset-0 z-10 flex items-center justify-center rounded-xl bg-neutral-hight-pure"
    >
      <p class="text-sm text-neutral-low-medium">Carregando checkout...</p>
    </div>
  }

  @if (iframeUrl()) {
    <iframe
      [src]="iframeUrl() | safeTransform: 'RESOURCE'"
      allow="payment; clipboard-read; clipboard-write; publickey-credentials-get; publickey-credentials-create;"
      class="absolute inset-0 h-full w-full rounded-xl border-none"
      title="Checkout"
      (load)="onIframeLoad()"
    ></iframe>
  }
</div>
